var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section is-white has-text-centered is-transparent"},[_c('span',{staticClass:"icon"},[_c('font-awesome-icon',{attrs:{"icon":"circle-notch","spin":"","size":"3x","color":"#455F83"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }